<template>
<div class="container">

<div class="row center empty" v-show="!list||list.length==0">
	<i class="fa fa-shopping-cart"></i>
	<p>购物车空空如也!</p>
</div>

<div class="row edit" v-if="list.length>0">
	<div class="col-8"></div>
	<div class="col-2"><mt-button size="small" class="btn" @click="edit">{{status==1?"编辑":"完成"}}</mt-button></div>
</div>

<div class="row item" v-for="(v,i) in list">
	<div class="col-1 check"  @click="select(v)" v-show="status==1">
		<i class="fa fa-check-circle red" v-show="v.check==1"></i>
		<i class="fa fa-circle-o gray" v-show="v.check==0"></i>
	</div>
	<div class="col-1 check" v-show="status==2" @click="del(v,i)">
		<i class="fa fa-trash-o red"></i>
	</div>
	<div class="col-3" @click="todetail(v)">
		<img :src="picurl+v.big_pic" :alt="v.name">
	</div>
	<div class="col-6">
		<div class="row" @click="todetail(v)">
			<h4>{{v.name}} </h4>
		</div>
		<div class="row gray pd">
			<span>数量：{{v.num}} </span>
			<span v-if="v.attrs>0">规格：{{v.attr_value}}</span>
		</div>
		<div class="row pd">
			<span class="red">¥<span class="price">{{v.price/100}}</span></span>
			<span class="gray oprice">¥{{v.oprice/100}}</span>
		</div>
	</div>
</div>

<div class="row tr bwhite total" v-show="list.length>0">
	共 {{totalnum}} 件，合计：<span class="red">¥<span class="price">{{totalprice/100}}</span></span>
</div>

<div class="yh" v-show="list.length>0">
<!-- <div class="row bwhite gray">
	<div class="col-2 center">优惠券</div>
	<div class="col-7"><span class="noyh">暂无可用的优惠券</span></div>
	<div class="col-1 center"><i class="fa fa-angle-right"></i></div>
</div> -->

<div class="row bwhite">
  <div class="col-2 center gray">留&nbsp;&nbsp;&nbsp;言</div>
  <div class="col-8">
  	<input type="text" placeholder="给商家留言" v-model="other"/>
  </div>
</div>
</div>

<!--
<div class="yh" v-show="list.length>0">
 <div class="row gray pay">
 	选择支付方式
 </div>
 <div class="row payi">
 	<i class="fa fa-check-circle red"></i>
 	<i class="fa fa-weixin"></i>
 	微信支付
 </div>
</div> -->

<div class="row mypay bwhite" v-show="status==1&&list.length>0">
	总计：<span class="red">¥<span class="price">{{totalprice/100}}</span></span>
	<mt-button class="btn-red" @click="sub">提交订单</mt-button>
</div>


</div>
</template>

<style scoped>
.container{background: rgb(251,251,251);padding-bottom: 3rem;}
.pd{padding:0 .3rem;}
.item{padding:.3rem 3%;border-bottom: 1px solid #eee;background: white;}
.item img{width:90%;margin:5%;}
.item h4{height:3.6rem;font-weight:500; }
.price{font-size: 1.3rem;}	
.oprice{text-decoration:line-through;}
.check{height:7.3rem;line-height: 7.3rem;text-align:center;font-size:1.3rem;}
.tr{text-align:right;padding:.5rem 1rem;}
.total{padding:.8rem;}
.yh{float:left;margin:.8rem 0;background: white;width:100%;}
.yh .row{padding:.5rem;}
.noyh{background:#ddd;color:white;padding:.2rem;}
input{width:100%;height:1.5rem;border:0;}
.pay{font-size:1.2rem;padding:.5rem;border-bottom:1px solid #eee;}
.fa-weixin{color:rgb(64,164,12);}
.yh .payi{padding:.7rem;}
.payi i{font-size:1.5rem;margin-right: .5rem;}
.payi .fa-check-circle{font-size: 1.2rem;}
.mypay{width:100%;height:3.5rem;line-height: 3.5rem;text-align:right;position: fixed;bottom:0;
	border-top:1px solid #eee;}
.btn-red{background: red;color:white;border-radius: 0;margin-left:.5rem;height:3.5rem;line-height: 3.5rem;}

.edit{padding:0 .5rem;text-align: right;background: white;border-bottom: 1px solid #eee;}
.btn{border:0;background: white;color: #aaa;font-size:1.1rem;box-shadow:0 0 0 white;}

</style>

<script>


export default {
  data:function(){
  	return {
  		list:"",
  		picurl:picurl,
  		other:"",
  		status:1,
  	}
  },
  created:function(){
  	this.$emit("setTitle","我的购物车");
  	this.init();
  },
  computed:{
  	totalnum:function(){
  		return this.count("num");
  	},
  	totalprice:function(){
  		return this.count("price")
  	}
  },
  methods:{
    init:function(){
            var _this=this;
            fun.post(mydata.apiuser+"mycar",{},function(d){
                console.log(d);
                if(d.status==1){
                    _this.list=d.info;
                    _this.count();
                }else{
                    _this.$toast(d.info);
                }
            })
        },
    select:function(v){
            v.check=v.check==1?0:1;
        },
    edit:function(){
            this.status=this.status==1?2:1;
    },
    del:function(v,i){
        console.log(v);
        var _this=this;
        this.$messagebox.confirm("确定移除该商品吗？").then(function(){
            fun.post(mydata.apiuser+"cardel",v,function(d){
            console.log(d);
            if(d.status==1){
                _this.list.splice(i,1);
                _this.status=1;
            }else{
                _this.$toast(d.info);
            }
            })
        },function(e){
        console.log(e);
        })	
    },
    todetail:function(v){
        this.$router.push("/mall/detail/ucode/"+v.gucode);
    },
    count:function(type){
        var len=this.list.length;
        var totalnum=0;
        var totalprice=0;
        for(var i=0;i<len;i++){
            if(this.list[i]['check']==1){
                totalnum+=parseInt(this.list[i]['num']);
                totalprice+=parseInt(this.list[i]['price']*this.list[i]['num']); 		  	
            }
        }
        if(type=="num"){
            return totalnum;
        }else{
            return totalprice;
        }
    },
    sub:function(){
        if(this.totalnum<1){return;}
        var _this=this;
        var data={
                list:JSON.stringify(this.list),
                other:this.other,
                wjtoken:fun.cookie("wjtoken"),
        };
        fun.post(mydata.apiuser+"toorder",data,function(d){
        console.log(d);
        if(d.status==1){
            _this.$router.push("/user/buy/"+d.info);
        }else{
            _this.$toast(d.info);
        }
        })
    }
  }
}	

</script>


// WEBPACK FOOTER //
// src/components/user/mycar.vue